export default {
  getLocale: state => state.locale,
  getDefaultPath: state => state.defaultPath
}
